import React from 'react';
import '../styles/Services.css';
import illustration from '../assets/images/services.png'; // Imagem da ilustração
import { FaCogs, FaProjectDiagram, FaHeadset, FaLightbulb } from 'react-icons/fa';

function Services() {
  return (
    <section id="services" className="py-5 bg-light">
      <div className="container">
        <h2 className="text-center mb-4">SERVIÇOS</h2>
        <p className="text-center mb-5">
          Oferecemos uma ampla gama de serviços para atender às necessidades tecnológicas da sua empresa.
          Nossa equipe especializada está pronta para desenvolver soluções personalizadas que impulsionam o seu negócio.
        </p>
        <div className="row align-items-center">
          <div className="col-lg-5 mb-4">
            <img src={illustration} alt="Serviços" className="img-fluid" />
          </div>
          <div className="col-lg-7">
            <div className="row g-4">
              <div className="col-md-6">
                <div className="card h-100 shadow-sm text-center p-3">
                  <div className="mb-3">
                    <FaCogs className="fs-1 text-primary" />
                  </div>
                  <h5>Desenvolvimento Personalizado</h5>
                  <p>Criamos soluções sob medida para atender às necessidades específicas do seu negócio.</p>
                </div>
              </div>
              <div className="col-md-6">
                <div className="card h-100 shadow-sm text-center p-3">
                  <div className="mb-3">
                    <FaProjectDiagram className="fs-1 text-success" />
                  </div>
                  <h5>Consultoria e Integração</h5>
                  <p>Consultoria especializada e integração de sistemas para otimizar processos empresariais.</p>
                </div>
              </div>
              <div className="col-md-6">
                <div className="card h-100 shadow-sm text-center p-3">
                  <div className="mb-3">
                    <FaHeadset className="fs-1 text-danger" />
                  </div>
                  <h5>Suporte e Manutenção</h5>
                  <p>Garantimos suporte contínuo e manutenção proativa para seus sistemas.</p>
                </div>
              </div>
              <div className="col-md-6">
                <div className="card h-100 shadow-sm text-center p-3">
                  <div className="mb-3">
                    <FaLightbulb className="fs-1 text-warning" />
                  </div>
                  <h5>Consultoria Estratégica</h5>
                  <p>Auxiliamos na tomada de decisões estratégicas com foco no crescimento do seu negócio.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Services;
